'use client';

import { c as _c } from "react/compiler-runtime";
import { LayoutStack } from 'design-system/client';
import styles from './PlatformForm.module.css';
import { Messages } from '@/components/Messages';
import type { DonationFormProps } from '@/donationForm/types';
import AddressFields from '@/donationPages/_dependencies/components/formParts/AddressFields';
import AddressFieldToggle from '@/donationPages/_dependencies/components/formParts/AddressFieldToggle';
import AmountAndIntervalSelection from '@/donationPages/_dependencies/components/formParts/AmountAndIntervalSelection';
import CodonationBox from '@/donationPages/_dependencies/components/formParts/CodonationBox';
import CompanyFields from '@/donationPages/_dependencies/components/formParts/CompanyFields';
import Debug from '@/donationPages/_dependencies/components/formParts/Debug';
import DonationFormCaptcha from '@/donationPages/_dependencies/components/formParts/DonationFormCaptcha';
import GeneralError from '@/donationPages/_dependencies/components/formParts/GeneralError';
import HeroImage from '@/donationPages/_dependencies/components/formParts/HeroImage';
import HolderFields from '@/donationPages/_dependencies/components/formParts/HolderFields';
import HolderHeadline from '@/donationPages/_dependencies/components/formParts/HolderHeadline';
import HolderTitle from '@/donationPages/_dependencies/components/formParts/HolderTitle';
import MessageField from '@/donationPages/_dependencies/components/formParts/MessageField';
import PaymentMethodError from '@/donationPages/_dependencies/components/formParts/PaymentMethodError';
import PaymentMethodSelection from '@/donationPages/_dependencies/components/formParts/PaymentMethodSelection';
import PlatformNewsletterCheckbox from '@/donationPages/_dependencies/components/formParts/PlatformNewsletterCheckbox';
import ProhibitedNotice from '@/donationPages/_dependencies/components/formParts/ProhibitedNotice';
import StripeCCFields from '@/donationPages/_dependencies/components/formParts/StripeFields/StripeCCFields';
import StripeSEPADebitFields from '@/donationPages/_dependencies/components/formParts/StripeFields/StripeSEPADebitFields';
import SubmitButton from '@/donationPages/_dependencies/components/formParts/SubmitButton';
import Terms from '@/donationPages/_dependencies/components/formParts/Terms';
import TotalDonationAmount from '@/donationPages/_dependencies/components/formParts/TotalDonationAmount';
import TrustLogos from '@/donationPages/_dependencies/components/formParts/TrustLogos';
import VotingQuestion from '@/donationPages/_dependencies/components/formParts/VotingQuestion';
import YoutubeFields from '@/donationPages/_dependencies/components/formParts/YoutubeFields';
import { useDonationFormValues } from '@/donationPages/_dependencies/helpers';
import { useShowPaymentError } from '@/helpers/hooks';
import useFeatureFlagLogging from './useFeatureFlagLogging';
function PlatformForm(t0) {
  const $ = _c(67);
  let bootstrapData;
  let children;
  let config;
  let initialFFs;
  let initialFormValues;
  let loggingData;
  let props;
  if ($[0] !== t0) {
    ({
      config,
      children,
      initialFormValues,
      initialFFs,
      bootstrapData,
      loggingData,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = bootstrapData;
    $[2] = children;
    $[3] = config;
    $[4] = initialFFs;
    $[5] = initialFormValues;
    $[6] = loggingData;
    $[7] = props;
  } else {
    bootstrapData = $[1];
    children = $[2];
    config = $[3];
    initialFFs = $[4];
    initialFormValues = $[5];
    loggingData = $[6];
    props = $[7];
  }
  const {
    donationsProhibited,
    receiverName,
    receiverProfilePicture,
    receiverUrl,
    showCodonation
  } = config;
  let t1;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["_company_donation"];
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  const [companyDonation] = useDonationFormValues(t1);
  let t2;
  if ($[9] !== bootstrapData || $[10] !== config || $[11] !== initialFormValues || $[12] !== loggingData) {
    t2 = {
      bootstrapData,
      initialFormValues,
      config,
      ...loggingData
    };
    $[9] = bootstrapData;
    $[10] = config;
    $[11] = initialFormValues;
    $[12] = loggingData;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  useFeatureFlagLogging(t2);
  useShowPaymentError();
  if (donationsProhibited) {
    let t3;
    if ($[14] !== receiverName || $[15] !== receiverProfilePicture || $[16] !== receiverUrl) {
      t3 = <HeroImage receiverName={receiverName} receiverProfilePicture={receiverProfilePicture} receiverUrl={receiverUrl} linked={true} />;
      $[14] = receiverName;
      $[15] = receiverProfilePicture;
      $[16] = receiverUrl;
      $[17] = t3;
    } else {
      t3 = $[17];
    }
    let t4;
    if ($[18] !== receiverUrl) {
      t4 = <ProhibitedNotice backHref={receiverUrl} />;
      $[18] = receiverUrl;
      $[19] = t4;
    } else {
      t4 = $[19];
    }
    let t5;
    if ($[20] !== t3 || $[21] !== t4) {
      t5 = <>{t3}{t4}</>;
      $[20] = t3;
      $[21] = t4;
      $[22] = t5;
    } else {
      t5 = $[22];
    }
    return t5;
  }
  let t3;
  if ($[23] !== receiverName || $[24] !== receiverProfilePicture || $[25] !== receiverUrl) {
    t3 = <HeroImage receiverName={receiverName} receiverProfilePicture={receiverProfilePicture} receiverUrl={receiverUrl} linked={true} />;
    $[23] = receiverName;
    $[24] = receiverProfilePicture;
    $[25] = receiverUrl;
    $[26] = t3;
  } else {
    t3 = $[26];
  }
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Messages />;
    t5 = <GeneralError />;
    t6 = <AmountAndIntervalSelection />;
    t7 = <VotingQuestion />;
    $[27] = t4;
    $[28] = t5;
    $[29] = t6;
    $[30] = t7;
  } else {
    t4 = $[27];
    t5 = $[28];
    t6 = $[29];
    t7 = $[30];
  }
  let t8;
  if ($[31] !== showCodonation) {
    t8 = showCodonation && <><CodonationBox /><hr className={styles.border} /><TotalDonationAmount /></>;
    $[31] = showCodonation;
    $[32] = t8;
  } else {
    t8 = $[32];
  }
  let t9;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <LayoutStack space="50" className={styles.blockWrapper}><PaymentMethodSelection /><StripeCCFields /><StripeSEPADebitFields /><PaymentMethodError /></LayoutStack>;
    $[33] = t9;
  } else {
    t9 = $[33];
  }
  let t10;
  let t11;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <HolderHeadline />;
    t11 = <HolderFields />;
    $[34] = t10;
    $[35] = t11;
  } else {
    t10 = $[34];
    t11 = $[35];
  }
  let t12;
  if ($[36] !== companyDonation) {
    t12 = !companyDonation && <><MessageField /><YoutubeFields /></>;
    $[36] = companyDonation;
    $[37] = t12;
  } else {
    t12 = $[37];
  }
  let t13;
  if ($[38] !== t12) {
    t13 = <LayoutStack space="300" className={styles.blockWrapper}>{t10}{t11}{t12}</LayoutStack>;
    $[38] = t12;
    $[39] = t13;
  } else {
    t13 = $[39];
  }
  let t14;
  if ($[40] !== companyDonation) {
    t14 = companyDonation && <LayoutStack className={styles.blockWrapper} space="400"><HolderTitle /><LayoutStack space="400"><CompanyFields /><AddressFields required={true} /><MessageField /><YoutubeFields /></LayoutStack></LayoutStack>;
    $[40] = companyDonation;
    $[41] = t14;
  } else {
    t14 = $[41];
  }
  let t15;
  if ($[42] !== companyDonation) {
    t15 = !companyDonation && <LayoutStack className={styles.blockWrapper} space="200"><AddressFieldToggle><AddressFields required={true} /></AddressFieldToggle></LayoutStack>;
    $[42] = companyDonation;
    $[43] = t15;
  } else {
    t15 = $[43];
  }
  let t16;
  let t17;
  let t18;
  let t19;
  let t20;
  if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <PlatformNewsletterCheckbox />;
    t17 = <SubmitButton />;
    t18 = <Terms />;
    t19 = <TrustLogos />;
    t20 = <DonationFormCaptcha />;
    $[44] = t16;
    $[45] = t17;
    $[46] = t18;
    $[47] = t19;
    $[48] = t20;
  } else {
    t16 = $[44];
    t17 = $[45];
    t18 = $[46];
    t19 = $[47];
    t20 = $[48];
  }
  let t21;
  if ($[49] !== t13 || $[50] !== t14 || $[51] !== t15) {
    t21 = <div className={styles.formFieldsContainer}>{t9}{t13}{t14}{t15}{t16}{t17}{t18}{t19}{t20}</div>;
    $[49] = t13;
    $[50] = t14;
    $[51] = t15;
    $[52] = t21;
  } else {
    t21 = $[52];
  }
  let t22;
  if ($[53] !== children || $[54] !== t21 || $[55] !== t8) {
    t22 = <div className={styles.donationFormContent}>{children}{t4}{t5}{t6}{t7}{t8}{t21}</div>;
    $[53] = children;
    $[54] = t21;
    $[55] = t8;
    $[56] = t22;
  } else {
    t22 = $[56];
  }
  let t23;
  if ($[57] !== props || $[58] !== t22) {
    t23 = <form {...props}>{t22}</form>;
    $[57] = props;
    $[58] = t22;
    $[59] = t23;
  } else {
    t23 = $[59];
  }
  let t24;
  if ($[60] !== initialFFs || $[61] !== initialFormValues) {
    t24 = <Debug initialFFs={initialFFs} initialFormValues={initialFormValues} />;
    $[60] = initialFFs;
    $[61] = initialFormValues;
    $[62] = t24;
  } else {
    t24 = $[62];
  }
  let t25;
  if ($[63] !== t23 || $[64] !== t24 || $[65] !== t3) {
    t25 = <>{t3}{t23}{t24}</>;
    $[63] = t23;
    $[64] = t24;
    $[65] = t3;
    $[66] = t25;
  } else {
    t25 = $[66];
  }
  return t25;
}
export default PlatformForm;